import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'keepInTouch/templates/<templateId>';

export function useKeepInTouchTemplateQuery({ id }: { id: string }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: !!id,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.KeepInTouchTemplate>(
				`keepInTouch/templates/${encodeURIComponent(id)}`,
				'GET'
			),
		queryKey: [BASE_QUERY_KEY, id],
		meta: {
			toastErrorMessage: 'Failed to load configuration',
		} satisfies LevStandardQueryMeta,
	});
}

export const invalidateKeepInTouchTemplateQueries = ({ id }: { id?: string } = {}) =>
	reactQueryClient.invalidateQueries({ queryKey: id ? [BASE_QUERY_KEY, id] : [BASE_QUERY_KEY] });
